import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {BotRule} from '../../models/bot-rule';
import {Observable, Subscriber} from 'rxjs';
import {ApiResponse} from '../../api/api-response';

@Injectable({
  providedIn: 'root'
})
export class BotRuleService extends AbstractModelService<BotRule> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/bot-rule', BotRule);
  }

  up(botRule: BotRule): Observable<void> {
    return new Observable<void>((subscriber: Subscriber<void>): void => {
      this.apiClient.post(this.routePath + '/' + botRule.id + '/up').subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  down(botRule: BotRule): Observable<void> {
    return new Observable<void>((subscriber: Subscriber<void>): void => {
      this.apiClient.post(this.routePath + '/' + botRule.id + '/down').subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
